export default "assets/images/icons/information-8042768d.svg";